import { environment } from './src/environments/environment';
import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1A_SIGNIN_ONLY_ROLES',
    editProfile: 'B2C_1_PasswordReset',
  },
  authorities: {
    signUpSignIn: {
      authority: environment.aadSignupSigninUrl,
    },
    editProfile: {
      authority: environment.aadEditprofileUrl,
    },
  },
  authorityDomain: environment.aadAuthorityDomain,
};

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.aadClientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: `${window.location.origin}/authentication/callback`,
    postLogoutRedirectUri: `${window.location.origin}/`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_logLevel, _message, _containsPii) => {
        // console.log(_logLevel, _message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};

export const protectedResources = {
  api: {
    endpoint: '/api',
    scopes: [environment.aadScope],
  },
};
export const loginRequest = {
  scopes: [],
};
